// Styles for HubHeroBasic go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledHubHeroBasic = styled.div`
  .hub-hero-basic {
    &-links {
      gap: ${toRem(16)};

      &.no-slider {
        margin-top: ${toRem(24)};
        margin-bottom: ${toRem(24)};
        justify-content: center;

        @media ${baseVariables.mediaQuery.lg} {
          margin-bottom: ${toRem(48)};
        }
      }

      width: fit-content;
      .hub-hero-basic-link {
        text-align: center;
      }
    }

    &-cta-link {
      padding-bottom: ${toRem(8)};
      color: ${contextualVariable.brandedAltColor};
      display: inline-block;
      border-bottom: ${toRem(0)};
      background: transparent;

      &:hover {
        color: ${contextualVariable.brandedAltColor};
        outline: none;
      }

      &.active {
        color: ${baseVariables.color['base10']};
        border-bottom: ${toRem(2)} solid ${contextualVariable.accentColor};
        outline: none;
      }
    }

    .center-align {
      height: ${toRem(30)};
    }

    .tabs-only {
      width: 100% !important;
    }

    .tab-controls {
      .right-arrow,
      .left-arrow {
        background-color: transparent;
        box-shadow: none;
        color: ${baseVariables.color['base10']};
        width: ${toRem(60)};
        height: ${toRem(40)};
        border-radius: 0;

        &:hover {
          background-color: transparent !important;
          color: ${baseVariables.color['base10']} !important;
        }
      }

      .right-arrow {
        right: ${toRem(-1)};
        justify-content: end;

        [dir='rtl'] & {
          left: unset;
          justify-content: start;
        }
        background: linear-gradient(
          270deg,
          #fff 0%,
          #fff 5%,
          rgba(255, 255, 255, 0.64) 100%,
          rgba(255, 255, 255, 0) 100%,
          rgba(255, 255, 255, 0) 100%
        );
      }

      .left-arrow {
        left: ${toRem(-1)};
        justify-content: start;

        [dir='rtl'] & {
          right: unset;
          justify-content: end;
        }
        background: linear-gradient(
          90deg,
          #fff 0%,
          #fff 5%,
          rgba(255, 255, 255, 0.64) 100%,
          rgba(255, 255, 255, 0) 100%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }
  }
`;
